import { useTenant } from 'probonio-shared-ui/module/me';

export function useWebAppUrl(): string {
  const { tenant } = useTenant();
  const baseUrl: string | undefined = import.meta.env.VITE_WEB_APP_URL;
  if (!baseUrl) {
    throw new Error('No url for web app provided');
  }
  if (!tenant || baseUrl.includes('localhost')) {
    return baseUrl;
  }

  const parts = baseUrl.split('.');
  // remove de from base url
  parts.pop();

  return [...parts, tenant.countryCode.toLowerCase()].join('.');
}
